import { useLocation, useNavigate } from "react-router-dom";
import "./Quiz.css";

function QuizResult() {

    const navigate = useNavigate();

    const location = useLocation();

    const {

        result,

        quiz,

        studentName

    } = location.state || {};

    if (!result || !quiz) {

        return (

            <div className="quiz-result-page">

                <h2>

                    No Result Found

                </h2>

                <button

                    onClick={() => navigate("/")}

                    className="home-btn"

                >

                    Go Home

                </button>

            </div>

        );

    }

    const percentage =
        (result.marksObtained / quiz.totalMarks) * 100;

    let title = "";
    let message = "";
    let emoji = "";
    let badge = "";

    if (percentage === 100) {

        title = "Excellent!";
        emoji = "🏆🌟🎉";
        badge = "Quiz Champion";
        message =
            "Amazing! You answered every question correctly! Keep shining!";

    }

    else if (percentage >= 75) {

        title = "Very Good!";
        emoji = "👏🌟";
        badge = "Math Star";
        message =
            "Excellent effort! Keep practicing and you'll reach perfection!";

    }

    else if (percentage >= 50) {

        title = "Good Job!";
        emoji = "😊👍";
        badge = "Practice Hero";
        message =
            "Well done! A little more practice and you'll score even higher.";

    }

    else {

        title = "Better Luck Next Time!";
        emoji = "💪📚";
        badge = "Keep Learning";
        message =
            "Don't worry! Every mistake helps you learn. Try again and you'll improve!";

    }

    return (

        <div className="quiz-result-page">

            <div className="quiz-result-card">

                <h1>

                    {emoji} Quiz Completed

                </h1>

                <h2>

                    {title} {studentName}

                </h2>

                <p className="result-message">

                    {message}

                </p>

                <div className="badge">

                    🏅 {badge}

                </div>

                <div className="result-details">

                    <p>

                        <strong>Subject :</strong> {quiz.subject}

                    </p>

                    <p>

                        <strong>Standard :</strong> {quiz.standard}

                    </p>

                    <p>

                        <strong>Marks Obtained :</strong> {result.marksObtained}

                    </p>

                    <p>

                        <strong>Total Marks :</strong> {quiz.totalMarks}

                    </p>

                    <p>

                        <strong>Percentage :</strong>

                        {percentage.toFixed(2)}%

                    </p>

                </div>

                <div className="review-section">

                    <h2>📖 Review Your Answers</h2>

                    {

                        result.review.map((item) => (

                            <div
                                key={item.questionNumber}
                                className="review-card"
                            >

                                <h3>

                                    Q{item.questionNumber}. {item.question}

                                </h3>

                                {

                                    item.options.map((option, index) => {

                                        const optionNumber = index + 1;

                                        let className = "review-option";

                                        if (optionNumber === item.correctAnswer) {

                                            className += " correct-option";

                                        }

                                        if (
                                            optionNumber === item.studentAnswer &&
                                            optionNumber !== item.correctAnswer
                                        ) {

                                            className += " wrong-option";

                                        }

                                        return (

                                            <div
                                                key={index}
                                                className={className}
                                            >

                                                {

                                                    optionNumber === item.correctAnswer &&
                                                    "✅ "

                                                }

                                                {

                                                    optionNumber === item.studentAnswer &&
                                                    optionNumber !== item.correctAnswer &&
                                                    "❌ "

                                                }

                                                {option}

                                            </div>

                                        );

                                    })

                                }

                                <div className="answer-status">

                                    {

                                        item.isCorrect

                                            ? "🎉 Correct Answer!"

                                            : "📚 Keep Practicing!"

                                    }

                                </div>

                            </div>

                        ))

                    }

                </div>

                <button

                    className="home-btn"

                    onClick={() => navigate("/")}

                >

                    Back To Home

                </button>

            </div>

        </div>

    );

}

export default QuizResult;